var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodatadiv"},[_c('div',[_c('img',{staticClass:"nodataimg",attrs:{"src":_vm.iconMatchEmpty}}),_vm._v(" "),_c('div',{staticClass:"nodatatest"},[_vm._v(" "+_vm._s(_vm.placeholder))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-656a296b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Common/MatchEmpty.vue
// module id = 632
// module chunks = 46